import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const steps = [{
  num: '01',
  title: 'Microthermal Zones (MTZs)',
  desc: 'Fractional lasers emit laser energy in a fractionated pattern, creating numerous tiny treatment zones on the skin. These MTZs are surrounded by unaffected tissue, which promotes faster healing and minimizes downtime.'
}, {
  num: '02',
  title: 'Stimulated Collagen Production',
  desc: "The controlled injuries caused by fractional lasers trigger the body's natural wound healing response. This process stimulates the production of collagen, a protein essential for skin elasticity, firmness, and hydration. Increased collagen production helps to improve skin texture, reduce fine lines and wrinkles, and promote a more youthful appearance."
}, {
  num: '03',
  title: 'Cell Turnover and Renewal',
  desc: "Fractional lasers promote cellular turnover and renewal by inducing controlled damage to the skin's surface. This encourages the shedding of old, damaged skin cells and the growth of new, healthier cells. As a result, the skin becomes smoother, brighter, and more radiant over time."
}, {
  num: '04',
  title: 'Targeted Treatment',
  desc: "Fractional lasers can be adjusted to target specific skin concerns, like fine lines, wrinkles, sun damage, age spots, and uneven skin tone. By precisely targeting these areas, fractional lasers provide customized treatment tailored to each patient's unique needs."
}, {
  num: '05',
  title: 'Safe and Controlled',
  desc: 'Fractional lasers are designed to deliver precise and controlled energy to the skin, minimizing the risk of complications and side effects. The depth and intensity of treatment can be adjusted based on factors like skin type, condition, and desired outcomes.'
}, {
  num: '06',
  title: 'Minimal Downtime',
  desc: "Because fractional lasers target only a fraction of the skin's surface at a time, the surrounding tissue remains unaffected. This results in faster healing and recovery compared to traditional ablative lasers."
}];
export function CBFractional() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-470">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-471">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-472">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-473">
            Be AMAZING
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-474">
            HOW FRACTIONAL LASERS WORK
          </h2>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body max-w-[800px] mb-6" data-id="element-475">
            Fractional lasers, including Clear + Brilliant Touch, work by
            delivering concentrated beams of light energy to the skin, targeting
            microscopic areas known as microthermal zones (MTZs). These lasers
            create controlled injuries within these zones, leaving surrounding
            tissue intact.
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-476"></div>
        </AnimateOnScroll>

        <div className="max-w-[900px] mx-auto" data-id="element-477">
          {steps.map((step, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-478">
              <div className={`py-8 ${index < steps.length - 1 ? 'border-b border-[#CCCCCC]' : ''}`} data-id="element-479">
                <div className="flex items-start gap-6" data-id="element-480">
                  <span className="text-[#F0D0E0] text-[72px] font-[700] font-[Poppins,_sans-serif] leading-none opacity-30 select-none flex-shrink-0 -mt-2" data-id="element-481">
                    {step.num}
                  </span>
                  <div data-id="element-482">
                    <h3 className="text-black text-xl font-bold font-[Poppins,_sans-serif] mb-2" data-id="element-483">
                      {step.title}
                    </h3>
                    <p className="text-[#333333] text-[15px] leading-[1.7] font-body" data-id="element-484">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}